import { type PropsWithChildren } from 'react';
import Animated, { Easing, FadeIn } from 'react-native-reanimated';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagPromptContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return <Animated.View entering={ENTERING_ANIMATION}>{children}</Animated.View>;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ENTERING_ANIMATION = FadeIn.duration(theme.transitions.base).easing(Easing.out(Easing.cubic));
